import script from "./AboutUsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUsDetail.vue?vue&type=style&index=0&id=8b371858&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b371858"]])

export default __exports__